// デジタル日時表示（v3 clockNumber.js のv4移植）。
// .js-year / .js-month / .js-day / .js-week / .js-week-short / .js-week-en-short / .js-time の
// 各要素に現在日時を1秒ごとに流し込む。記事アサイドのカレンダーカードで使用。
export function clockNumber() {
  const yearEls = document.querySelectorAll('.js-year');
  const monthEls = document.querySelectorAll('.js-month');
  const dayEls = document.querySelectorAll('.js-day');
  const weekEls = document.querySelectorAll('.js-week');
  const weekShortEls = document.querySelectorAll('.js-week-short');
  const weekEnShortEls = document.querySelectorAll('.js-week-en-short');
  const timeEls = document.querySelectorAll('.js-time');
  if (!(yearEls.length || monthEls.length || dayEls.length || weekEls.length || weekShortEls.length || weekEnShortEls.length || timeEls.length)) return;

  // 英数字を全角にする（v3と同じ見た目を保つ）
  function zenkaku(str) {
    return String(str).replace(/[A-Za-z0-9]/g, (s) => String.fromCharCode(s.charCodeAt(0) + 0xFEE0));
  }

  // 0〜9の数値を2桁にする（例: 0:0:0 -> 00:00:00）
  function formatTime(val) {
    return ('0' + val).slice(-2);
  }

  const update = () => {
    const now = new Date();
    const day = now.getDay();
    const weekday = ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'];
    const weekdayShort = ['日', '月', '火', '水', '木', '金', '土'];
    const weekdayEnShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const time = `${zenkaku(formatTime(now.getHours()))}:${zenkaku(formatTime(now.getMinutes()))}:${zenkaku(formatTime(now.getSeconds()))}`;

    yearEls.forEach((el) => { el.innerText = now.getFullYear(); });
    monthEls.forEach((el) => { el.innerText = now.getMonth() + 1; });
    dayEls.forEach((el) => { el.innerText = now.getDate(); });
    weekEls.forEach((el) => { el.innerText = zenkaku(weekday[day]); });
    weekShortEls.forEach((el) => { el.innerText = zenkaku(weekdayShort[day]); });
    weekEnShortEls.forEach((el) => { el.innerText = weekdayEnShort[day]; });
    timeEls.forEach((el) => { el.innerText = time; });
  };

  update();
  setInterval(update, 1000);
}
